import { Modal, ModalHeader, ModalBody } from 'baseui/modal'
import { HeaderContainer, TitleText, OptionsContainer, StyledIcon } from './styled-components'

import AddIcon from './add.svg'
import useCreateContractModal from './useCreateContractModal'
import OptionCard from './OptionCard'
import {
  BUSINESS_VERTICAL_ENERGY,
  BUSINESS_VERTICAL_INSURANCE,
  BUSINESS_VERTICAL_TELECOM,
} from '../../SubscriptionForm/Common/constants'
import NoOption from './NoOption'
import ModalButtons from './ModalButtons'
import useCreateContractModalStyles from './useCreateContractModalStyles'

const CreateContractModal = () => {
  const {
    createContractSelectedType,
    t,
    isAllowedEnergyVertical,
    isAllowedInsuranceVertical,
    isAllowedTelecomVertical,
    noOptionsAllowed,
    isInvalidSelectedType,
    addContractModal,
    toggleContractModal,
    handleConfirm,
    handleCancel,
    handleSelectOption,
  } = useCreateContractModal()
  const { isPulse, modalOverrides } = useCreateContractModalStyles()

  return (
    <Modal isOpen={addContractModal} onClose={toggleContractModal} overrides={modalOverrides}>
      <ModalHeader>
        <HeaderContainer $pulse={isPulse}>
          <StyledIcon src={AddIcon} alt={t('subscriptionForm:contract_modal.title')} $pulse={isPulse} />
          <TitleText $pulse={isPulse}>{t('subscriptionForm:contract_modal.title')}</TitleText>
        </HeaderContainer>
      </ModalHeader>
      <ModalBody>
        <OptionsContainer $pulse={isPulse}>
          <OptionCard
            onClick={() => handleSelectOption(BUSINESS_VERTICAL_ENERGY)}
            hidden={!isAllowedEnergyVertical}
            selected={createContractSelectedType === BUSINESS_VERTICAL_ENERGY}
            text={t('subscriptionForm:contract_modal.energy')}
            iconName={BUSINESS_VERTICAL_ENERGY}
          />
          <OptionCard
            onClick={() => handleSelectOption(BUSINESS_VERTICAL_TELECOM)}
            hidden={!isAllowedTelecomVertical}
            selected={createContractSelectedType === BUSINESS_VERTICAL_TELECOM}
            text={t('subscriptionForm:contract_modal.telecom')}
            iconName={BUSINESS_VERTICAL_TELECOM}
          />
          <OptionCard
            onClick={() => handleSelectOption(BUSINESS_VERTICAL_INSURANCE)}
            hidden={!isAllowedInsuranceVertical}
            selected={createContractSelectedType === BUSINESS_VERTICAL_INSURANCE}
            text={t('subscriptionForm:contract_modal.insurance')}
            iconName={BUSINESS_VERTICAL_INSURANCE}
          />
          <NoOption hidden={!noOptionsAllowed} />
        </OptionsContainer>
        <ModalButtons
          hidden={noOptionsAllowed}
          onCancel={handleCancel}
          onConfirm={handleConfirm}
          disabled={isInvalidSelectedType}
        />
      </ModalBody>
    </Modal>
  )
}

export default CreateContractModal
